module.exports = __webpack_public_path__ + "img/background.8b7b177b.png";